import { SystemMessage } from 'components/Dialogue';
import { BaseSysMsgProps } from './types';
import { useTranslate } from '@tolgee/react';
import { memo } from 'react';

export const SysAsteriskStarMsg = memo((props: BaseSysMsgProps) => {
  const { raw } = props;
  const { t } = useTranslate();

  return (
    <SystemMessage>
      {raw.sysAsteriskContent?.color === 'NO_STAR'
        ? t('ViewsChat.星标取消', {
            who: raw.sysAsteriskContent?.assistantName,
          })
        : t('ViewsChat.星标标记', {
            who: raw.sysAsteriskContent?.assistantName,
            color: t(`filter.${raw.sysAsteriskContent?.color!}`),
          })}
    </SystemMessage>
  );
});
